module.exports = __webpack_public_path__ + "img/caipin_empty.99b40a60.png";